module.exports = __webpack_public_path__ + "static/media/IconChecked.cf2c0dfa.svg";